// extracted by mini-css-extract-plugin
export default {"container":"TermsCondition_container__UzFXV"};